import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  ManufacturerImportAction,
  addManufacturerAction,
  deleteManufacturerAction,
  manufacturerTableListAction,
  updateManufacturerAction,
} from "../../../../redux/actions/settings-action";
import errorToast from "../../../helper-components/error-toast";
import successToast from "../../../helper-components/success-toast";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import AddButton from "../../../buttons/button";
import search from "../../../../assets/icons/searchIcon.svg";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import excelImg from "../../../../assets/icons/excel.png";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import {
  downloadAllTemplates,
  downloadAllTemplatesJson,
} from "../../../helper-components/helper-function";
import DownloadIcon from "../../../../assets/icons/download-icon";
import { FileJson, Search } from "lucide-react";

const ManufacturerSetup = () => {
  const tableHeading = ["Manufacturer Code", "Manufacturer Name", "Actions"];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [initialData, setManufacturerListData] = useState([]);
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [mainloading, setmainLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };
  useEffect(() => {
    dispatch(
      manufacturerTableListAction(
        {},
        onFetchManufacturerListSuccess,
        onFetchManufacturerError
      )
    );
    // setmainLoading(true);
  }, []);

  useEffect(() => {
    dispatch(
      manufacturerTableListAction(
        { searchValue },
        onFetchManufacturerListSuccess,
        onFetchManufacturerError
      )
    );
    // setmainLoading(true);
  }, [searchValue, reload]);

  const reloadData = () => {
    dispatch(
      manufacturerTableListAction(
        {},
        onFetchManufacturerListSuccess,
        onFetchManufacturerError
      )
    );
    // setmainLoading(true);
  };

  const onFetchManufacturerListSuccess = (data) => {
    setManufacturerListData(data?.data?.manufacturerList);
    setmainLoading(false);
  };

  const onFetchManufacturerError = (data) => {
    setmainLoading(false);
    errorToast(data?.data?.message);
    setManufacturerListData([]);
  };

  const initialValues = {
    data: initialData,
    newLine: { code: "", name: "" },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;

    // Collect changed array data
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        changedObjects.push(values.data[index]);
      }
    });

    // Collect new line data if it is altered
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }

    if (newLineObject !== null) {
      dispatch(
        addManufacturerAction(newLineObject, onCreateSuccess, onCreateError)
      );
    }

    if (changedObjects.length > 0) {
      dispatch(
        updateManufacturerAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }

    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onUpdateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    setmainLoading(false);

    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onClickDelete = (id) => {
    dispatch(deleteManufacturerAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    // setmainLoading(false);

    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };

  const onError = (data) => {
    setmainLoading(false);
    selectedDOtIndex(null);
    errorToast(data?.message);
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  const TemplateArray = [
    {
      documentType: "Manufacturer Setup",
      expectedHeaders: ["name", "code"],
    },
  ];

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const { handleFileUpload, loading } = useCsvUpload(
    ManufacturerImportAction,
    TemplateArray?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="manufacturer-setup"
      // permissionFn={permissionFn}
    >
      <div className="mx-6">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ values, setFieldValue, dirty, handleSubmit }) => (
            <Form className="pt-1">
              <div
                className="flex flex-col gap-3"
                style={{ height: "85vh" }}
                onClick={handleClickOutside}
              >
               
                <div className="flex justify-between items-center">
                  <div className=" flex items-center gap-2 text-sml ">
                    <button
                      className="flex items-center gap-2"
                      onClick={() => {
                        navigate("/settings");
                      }}
                    >
                      <ChevronLeftIcon className="h-5 w-5 inline-block " />
                      Data Setup Settings /
                    </button>
                    <span className="cursor-pointer">
                      {" " + "Manufacturer Setup"}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 pr-3">
                    <div
                      style={{ minWidth: "18rem", height: "2.5rem" }}
                      className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
                    >
                      <input
                        // ref={searchRef}
                        placeholder={`Search (/)`}
                        className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                        type="text"
                        value={searchValue}
                        onChange={(e) => {
                          setSearchValue(e?.target?.value);
                        }}
                      />
                      <span className="px-2">
                        {" "}
                        {<Search size="16" color="#9CA3AF" />}
                      </span>
                    </div>
                    <div className=" flex flex-row gap-3">
                      <div>
                        <input
                          type="file"
                          accept=".csv,.json"
                          onChange={(e) =>
                            handleFileUpload(e, onSuccess, onError)
                          } // Pass onSuccess and onError functions
                          className="hidden"
                          id="csv-upload"
                        />
                        <label htmlFor="csv-upload">
                          <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                            <img
                              width={20}
                              height={30}
                              src={excelImg}
                              alt="excel-icon"
                            />
                            <FileJson width={20} height={20} className="flex-shrink-0" />
                            {loading ? (
                              <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                            ) : (
                              <span>Import CSV / JSON</span>
                            )}
                          </div>
                        </label>
                      </div>
                      <span title="Download CSV Template">
                        <button
                          type="button"
                          onClick={() => {
                            downloadAllTemplates(TemplateArray);
                          }}
                          className="border-027A48 border-2 rounded-md px-2 py-2"
                        >
                          <DownloadIcon fill="var(--success-color)" />
                        </button>
                      </span>
                      <span title="Download JSON Template">
                        <button
                          type="button"
                          onClick={() => {
                            downloadAllTemplatesJson(TemplateArray);
                          }}
                          className="border-027A48 border-2 rounded-md px-2 py-2"
                        >
                          <DownloadIcon fill="var(--success-color)" />
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                {mainloading ? (
                  <LoadingSpinner />
                ) : (
                  <div className="overflow-auto rounded-xl table-container border border-gray-200">
                    <table className=" w-full ">
                      <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                        <tr className="relative h-[50px]">
                          {tableHeading.map((heading, index) => (
                            <th
                              className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                              key={heading}
                            >
                              {heading?.toUpperCase()}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="">
                        {values.data.map((item, index) => (
                          <tr key={index}>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary w-3/12`}
                            >
                              <Field
                                name={`data[${index}].code`}
                                placeholder="Code"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "code",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                              />
                            </td>
                            <td
                              className={`tab-cell text-sm fw_400 text-secondary`}
                            >
                              <Field
                                name={`data[${index}].name`}
                                placeholder="Name"
                                disabled={disableArrayFields}
                                onChange={(e) =>
                                  handleFieldChange(
                                    `data[${index}]`,
                                    "name",
                                    e.target.value,
                                    setFieldValue
                                  )
                                }
                                className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                              />
                            </td>
                            <td className="tab-cell  w-[5rem] text-sm fw_400 text-secondary p-8">
                              <button
                                onClick={() => setSelectedDOtIndex(index)}
                              >
                                <KibabMenu />
                              </button>
                              {selectedDOtIndex === index && (
                                <div
                                  ref={componentRef}
                                  style={{
                                    position: "absolute",
                                    right: "5rem",
                                    boxShadow:
                                      "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                  }}
                                  className="bg-white rounded "
                                >
                                  <div className="w-full p-2">
                                    <button
                                      className="w-full flex align-middle gap-2 px-2 py-1"
                                      onClick={() => onClickDelete(item?.id)}
                                    >
                                      <div className="mt-1">
                                        <DeleteIcon />
                                      </div>
                                      <span className="text-sm">Delete</span>
                                    </button>
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary w-3/12`}
                          >
                            <Field
                              name="newLine.code"
                              placeholder="Code"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "code",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                              autoFocus={searchValue ? false : true}
                            />
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary`}
                          >
                            <Field
                              name="newLine.name"
                              placeholder="Name"
                              disabled={disableNewFields}
                              onChange={(e) =>
                                handleFieldChange(
                                  "newLine",
                                  "name",
                                  e.target.value,
                                  setFieldValue
                                )
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
                <AddButton
                  onclkFn={handleSubmit}
                  prefixIcon={false}
                  text="Save"
                  type="submit"
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </InnerLayout>
  );
};

export default ManufacturerSetup;
